export default __webpack_public_path__ + "static/media/logo-long.e09d92cc.png";